import { render } from "./comodule.vue?vue&type=template&id=45987104"
import script from "./comodule.vue?vue&type=script&lang=js"
export * from "./comodule.vue?vue&type=script&lang=js"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__